import { skipToken } from '@reduxjs/toolkit/query';
import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { useGetSectionsQuery } from 'services/api/vehicle-sections';
import { Section, SectionImage } from 'services/api/vehicle-sections/types';
import { useExteriorSectionData } from './useExteriorSection';
import { useTireImages } from './useTireImages';

const TIRES_DISPLAY_KEYS = [
  'driver_front_tire',
  'driver_front_wheel',
  'passenger_front_tire',
  'passenger_front_wheel',
  'driver_rear_tire',
  'driver_rear_wheel',
  'passenger_rear_tire',
  'passenger_rear_wheel',
  'tires_match_manufacturer',
] as const;

export const useTiresSection = (): { section: Section | undefined; orderedImages: (SectionImage | undefined)[] } => {
  const vehicleId = useGetVehicleId();
  const { data: sections } = useGetSectionsQuery(vehicleId || skipToken);
  const { subSections } = useExteriorSectionData('tires');
  const orderedImages = useTireImages({ raw: true });

  const rawSection = sections?.exterior?.subsections?.tires;
  const subsections: Record<string, Section> = {};

  TIRES_DISPLAY_KEYS.forEach(key => {
    const sub = subSections[key];
    if (!sub) return;
    const numericGrade = key.endsWith('_tire')
      ? orderedImages.find(img => img?.type === `tires.${key}`)?.grade
      : undefined;
    if (sub.grade || numericGrade) subsections[key] = sub;
  });

  return {
    section: rawSection ? { ...rawSection, subsections } : undefined,
    orderedImages,
  };
};
